// src/shared/offer-config.ts
import { environment } from '../config'
import { AppRoutes } from './app-routes'

export type OfferDiscountIds = Record<AppRoutes.Webinar | AppRoutes.WebinarB, string>

const stagingDiscountIds: OfferDiscountIds = {
  [AppRoutes.Webinar]: 'dsc_01kzdynvdhgg92atb674bak046',
  [AppRoutes.WebinarB]: 'dsc_01kkweb386wpfwxgnnw5cahfdh',
}

const productionDiscountIds: OfferDiscountIds = {
  [AppRoutes.Webinar]: 'dsc_01kzngjc5fv51h4f9pgzp7xsh2',
  [AppRoutes.WebinarB]: 'dsc_01kkxbh9xs8dh6ajh46fc8xmkj',
}

export const OfferConfig = {
  discountIds: environment === 'production' ? productionDiscountIds : stagingDiscountIds,
} as const
